let body = $("html, body");


function custom() {
    // let test = 'es6 is working'
    // console.log(test)
    $('.main-nav .nav-item-dropdown').click(function (event) {

        let navDropdown = $(this);
        $('.main-nav .nav-item-dropdown').not(navDropdown).find('.mobile-active').addClass('ddddd').removeClass('mobile-active');

        $('.main-nav .nav-item-dropdown').not(navDropdown).find('.sub-menu.dropdown-active').removeClass('dropdown-active');




        event.preventDefault();
        navDropdown.find('.sub-menu').toggleClass('dropdown-active');
        navDropdown.find('.hvr-underline-reveal').toggleClass('mobile-active');
        navDropdown.find('.icon-dropdown').toggleClass('toggle');
    });
    $('.sub-menu .sub-menu-link').click(function (event) {
        event.stopPropagation();
    });

    // min Height Page Containe


    function InitMainWrappElements() {

        var cont_wdth = $('.main-outer-wrapp').outerWidth();

        $(".main-outer-wrapp .text-toggle").each(function (index) {
            let button = $(this),
                first_parent = button.closest('.first-parent'),
                first_parent_pos = button.closest('.first-parent').position().left + 15,
                defaultHeight = 0,
                textToggle = button.parents('.sec-sponsors').find('.text-toggle')
            $(button).css({
                "width": cont_wdth,
                "margin-left": -(first_parent_pos)

            });



        })
    }
    window.onresize = function (event) {
        if ($('.main-outer-wrapp').length) {
            InitMainWrappElements()
        }
        inniChatWindow();
    };

    if ($('.main-outer-wrapp').length) {


        InitMainWrappElements()


        $(".btn-text-toggle").each(function (index) {


            let button = $(this)


            button.on("click", function () {
                let thisDataWrapp = $('#' + $(this).data('toshow'));
                if (button.hasClass('active')) {
                    $(thisDataWrapp).removeClass('activedata').slideUp();

                    $(".btn-text-toggle").removeClass("active");
                    body.stop().animate({
                        scrollTop: button.offset().top - $(this).outerHeight()
                    }, 800, 'swing', function () {});


                } else {
                    //
                    if (($('.text-toggle.activedata').length > 0) && (!button.hasClass('active'))) {

                        $('.text-toggle.activedata').hide();
                        $(thisDataWrapp).addClass('activedata').show().slideDown();
                        body.stop().animate({
                            scrollTop: thisDataWrapp.offset().top - $(this).outerHeight()
                        }, 800, 'swing', function () {});


                    } else {
                        $(thisDataWrapp).addClass('activedata').slideDown();
                        body.stop().animate({
                            scrollTop: thisDataWrapp.offset().top - $(this).outerHeight()
                        }, 800, 'swing', function () {});

                    }
                    // //






                    $(".btn-text-toggle").removeClass("active");
                    button.toggleClass("active");


                }




            })



        })



    }
    if ($('.text-toggle-1').length) {
        // Text Toggl
        $(".btn-text-toggle").each(function (index) {
            let button = $(this),
                defaultHeight = 0,
                textToggle = button.parents('.sec-sponsors').find('.text-toggle'),
                text = button.parents('.sec-sponsors').find('#' + $(this).data('sponsors')),
                textHeight = text[0].scrollHeight,
                newHeight = 0,
                defaultBottom = 0,
                calcTop = button.offset().top - $(".sec-sponsors").offset().top,
                topPoint = calcTop + button.innerHeight() + 20;
            $(".text-toggle").css({
                "max-height": defaultHeight,
                "overflow": "hidden"
            });
            $(".btn-text-toggle").css({
                "margin-bottom": defaultBottom
            });
            button.on("click", function () {
                let dataAttr = button.data('textrow');
                // alert($('#' + $(this).data('scroll')))

                setTimeout(function () {
                    $('.display-data').css({
                        "top": topPoint + "px"
                    });
                }, 500);


                if ($('.display-data').position().top == topPoint) {
                    // alert(topPoint);
                    // alert($(".btn-text-toggle").data('scroll'))
                    // alert(dataAttr);
                    // if (dataAttr == dataAttr) {
                    newHeight = textHeight;
                    // console.log($(".btn-text-toggle[data-scroll='" + dataAttr + "']"));
                    // $(".btn-text-toggle").animate({ "margin-bottom": defaultBottom }, 300);
                    // button.animate({ "margin-bottom": newHeight }, 300);
                    if ($(window).width() < 1200) {
                        // alert('111');
                        $(".btn-text-toggle").animate({
                            "margin-bottom": defaultBottom
                        }, 300);
                        button.animate({
                            "margin-bottom": newHeight
                        }, 300);
                    } else {
                        $(".btn-text-toggle[data-textrow='" + dataAttr + "']").animate({
                            "margin-bottom": newHeight
                        }, 300);

                    }
                    // }
                    text.addClass("active").siblings().removeClass("active");
                    $(".btn-text-toggle").removeClass("active");
                    text.show().siblings().hide();
                    button.addClass("active");
                    button.animate({
                        "margin-bottom": newHeight + "px"
                    }, 500);
                    setTimeout(function () {
                        text.animate({
                            "max-height": newHeight
                        }, 500);
                    }, 300);

                } else {
                    // alert('here')
                    text.show().siblings().hide();
                    $('.btn-text-toggle').removeClass('active');
                    button.addClass("active");
                    // alert($(this).data('sponsors'));
                    if (text.hasClass("active")) {
                        newHeight = defaultHeight;
                        text.removeClass("active");
                        button.removeClass("active");
                    } else {
                        newHeight = textHeight;

                        // textToggle.hide().siblings().show();
                        textToggle.animate({
                            "max-height": defaultHeight
                        }, 500);


                        $(".btn-text-toggle").animate({
                            "margin-bottom": defaultBottom + "px"
                        }, 500);

                    }
                    // setTimeout(function() {
                    button.animate({
                        "margin-bottom": newHeight + "px"
                    }, 500);

                    text.animate({
                        "max-height": newHeight
                    }, 500);
                    // }, 300);
                    // console.log(newHeight);
                }

            });
        });
    }
    // Scroll To Section
    $(".scroll-to-sec").each(function () {
        $(this).click(function () {
            $('html, body').animate({
                scrollTop: $('#' + $(this).data('scroll')).offset().top - 20
            }, 500);
        });

    });

    if ($('.wrap-mobile-menu').length > 0) {
        $('.navbar-toggler').click(function () {
            $('body , .header').toggleClass('opened-header');
            if ($(this).hasClass('collapsed')) {
                setTimeout(function () {
                    inniChatWindow()
                }, 100);
            } else {

                setTimeout(function () {

                    inniChatWindow()
                }, 250);
            }

            setTimeout(function () {
                inniChatWindow()
            }, 300);

        })
    }



    $(document).on('click', function (e) {
        var accordion = $(".join-businesses");
        var collapse = $(".join-businesses .collapse");

        if (!$(e.target).closest(accordion).length) {
            collapse.collapse('hide');
        }


        if ($(window).width() < 576) {
            var header = $(".header");
            var collapse_header = $(".header .navbar-collapse");

            if (!$(e.target).closest(header).length) {
                collapse_header.collapse('hide');
                $('body , .header').removeClass('opened-header');
                inniChatWindow();
                setTimeout(function () {
                    inniChatWindow();
                }, 300);
            }
        }
    });

    // Photo Gallery
    // $('.wrapper-photo-gallery').each(function() {
    //     $(this).click(function() {
    //         // alert('1');
    //         $('.photo-gallery').slideToggle();
    //     });
    // });

    // Rest Form
    $('.btn-reset-form').click(function () {
        $(this).parents('.reset-form').get(0).reset()
    });


    function inniChatWindow() {
        let vh = (window.innerHeight * 0.01) * 100;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        let nvh = document.documentElement.style.getPropertyValue('--vh')
        // if ($(window).scrollTop() + $(window).height() >= $(document).height() - 30) {
        //     $('.join-businesses').css({
        //         'margin-bottom': $('.footer').innerHeight() + 'px'
        //     });
        // } else {
        //     $('.join-businesses').css({
        //         'margin-bottom': '0px'
        //     });
        // }
        $('.page-container').css({
            'min-height': 'calc(' + nvh + ' - ' + ($('.header').innerHeight() + $('.footer').innerHeight() + $('.sticky-pos.top-aligned').innerHeight()) + 'px)'
            //'min-height':'calc(100vh - ' + ($('.header').innerHeight() + $('.footer').innerHeight()) + 'px)'
        });
        if (($('.homepage-gallery').length) > 0) {
            let headerHeight = $('.header').innerHeight() + $('.sticky-pos.top-aligned').innerHeight();
            let footerHeight = $('.footer').innerHeight();
            $('.homepage-gallery,.homepage-gallery>div ,.homepage-gallery .slick-list').css({
                'height': 'calc(' + nvh + ' - ' + (headerHeight + footerHeight) + 'px)'


            });
        }


        // if ($(window).scrollTop() >= $(
        //         '.page-container').offset().top + $('.page-container').outerHeight() - window.innerHeight) {

        //     $('.join-businesses').css({
        //         'margin-bottom': $('.footer').innerHeight() + 'px'
        //     });
        // } else {
        //     $('.join-businesses').css({
        //         'margin-bottom': '0px'
        //     });
        // }
        if ($(window).scrollTop() >= 20 + $(
                '.page-container').offset().top + $('.page-container').outerHeight() - window.innerHeight) {

            $('.join-businesses').css({
                'bottom': $('.footer').innerHeight() + 'px',
                "position": "absolute"
            });
        } else {
            $('.join-businesses').css({
                'bottom': '0px',
                "position": "fixed"

            });
        }

    };
    inniChatWindow();
    $(window).scroll(function () {
        inniChatWindow();

    });




    if (($('.top-note-banner .remove-msg').length) > 0) {
        el = $('.top-note-banner');

        if (sessionStorage.getItem('ShowTopNoteBanner') !== null) {

            el.remove();
            inniChatWindow()
        }
        $('.remove-msg').click(function () {
            el = $('.top-note-banner');
            // el.hide('fast', function () {
            //     el.remove();
            //     inniChatWindow()
            // });
            el.animate({
                opacity: '0'
            }, 150, function () {
                el.animate({
                    height: '0px'
                }, 150, function () {

                    sessionStorage.setItem('ShowTopNoteBanner', 'true');





                    el.remove();
                    inniChatWindow()
                });
            });
        })
    }

    // if ($('.homepage-gallery').length) {
    //     // Bottom
    //     $('.join-businesses').css({
    //         'bottom': $('.footer').innerHeight() + 'px'
    //     });
    // }

}


custom();



$(document).ready(function () {
    setTimeout(function () {
        $('.loading_overlay').fadeOut();
    }, 200);

    // Check if body height is higher than window height
    if ($("body").height() < $(window).height()) {
        // $('.join-businesses').css({
        //     'bottom': $('.footer').innerHeight() + 'px'
        // });
    }



    var queryString = window.location.search;
    console.log('queryString', queryString);
    var urlParams = new URLSearchParams(queryString);



    var section_id = urlParams.get('section-id');
    console.log('section_id', section_id)
    if ($('#' + section_id).length) {
        $('html, body').animate({
            scrollTop: $('#' + section_id).offset().top
        }, 1000);
    }



});

if ($('[data-toggle="tooltip"]')) {
    $('[data-toggle="tooltip"]').tooltip()

}